module.exports = __webpack_public_path__ + "img/20210430_110657.df86a4ea.jpg";